import { Component, OnInit } from "@angular/core";
import { Iso3166_1, Language } from "../../../_model/Language";
import { PHBGlobals } from "../../../_config/config";
import { LanguageService } from "../../services/language";
import { MatDialog } from "@angular/material/dialog";
import { LanguageModalComponent } from "./language-modal/language-modal.component";
import { User } from "../../../_model/user";

@Component({
	selector: "language-header",
	templateUrl: "./language-header.component.html",
	styleUrls: ["./language-header.component.scss"],
	standalone: true,
	imports: []
})
export class LanguageHeaderComponent implements OnInit {

	get isGerman(): boolean {
		const browserLang = navigator.language || (navigator as any).userLanguage;
		return browserLang && browserLang.toLowerCase().startsWith("de");
	}

	get currentUser(): User {
		return PHBGlobals.user;
	}

	get disabled(): boolean {
		return !PHBGlobals.useTranslationFallback;
	}

	get languages(): Language[] {
		return PHBGlobals.plainLanguages.filter(it => {
			return PHBGlobals.user.languages.includes(it.isocode);
		});
	};

	get language(): Language {
		return PHBGlobals.getLanguage();
	};

	constructor(private languageService: LanguageService, private dialog: MatDialog) {
	}

	ngOnInit() {
		if(PHBGlobals.languages && !PHBGlobals.languages[PHBGlobals.currentLanguage]){
			PHBGlobals.currentLanguage = "en";
		}
	}

	togglePopOver() {
		if (this.languages.length <= 1) {
			return;
		}

		const dialogRef = this.dialog.open(LanguageModalComponent, {
			width: "600px",
			maxWidth: "90vw"
		});

		dialogRef.afterClosed().subscribe((result: { language: Language, country: Iso3166_1 | null }) => {
			if (result) {
				this.changeLanguage(result.language, result.country);
			}
		});
	}

	async changeLanguage(language: Language, country: Iso3166_1 | null) {
		if (country) {
			PHBGlobals.currentCountry = country;
		}
		PHBGlobals.languageChanged.emit(language.isocode);
		this.languageService.loadTranslations();
	}

	protected readonly PHBGlobals = PHBGlobals;
}
